import { ProfessionalSubCategoryCountryConfiguration } from "./professional-sub-category";

export class ProfessionalSubCategoryDTO {
  subCategoryID: number;
  subCategoryName: string;
  categoryID: number;
  isUserDefined: boolean;
  countryID: number;
  professionalSubCategoryCountryConfiguration: ProfessionalSubCategoryCountryConfiguration;

  public static isEnabledForNewObservations(professionalSubCategory: ProfessionalSubCategoryDTO) {
    if(!professionalSubCategory.isUserDefined && !professionalSubCategory.professionalSubCategoryCountryConfiguration){
      return true;
    }else{ 
      return professionalSubCategory.professionalSubCategoryCountryConfiguration?.isEnabledForNewObservations || false;
    }
  }

  public static getName(professionalSubCategory: ProfessionalSubCategoryDTO) {
    if (!professionalSubCategory.professionalSubCategoryCountryConfiguration)
      return professionalSubCategory.subCategoryName;
    else
      professionalSubCategory.professionalSubCategoryCountryConfiguration.subCategoryName;
  }
}

